// Announcements constants. Option values must match the backend whitelist
// (server.js): target_dept and target_audience.

export const DEPT_OPTIONS = [
  { value: 'all', label: 'All Departments' },
  { value: 'sales', label: 'Sales' },
  { value: 'hr', label: 'HR' },
  { value: 'it', label: 'IT' },
  { value: 'digital_marketing', label: 'Digital Marketing' },
  { value: 'management', label: 'Management' },
];

export const AUDIENCE_OPTIONS = [
  { value: 'all', label: 'Everyone' },
  { value: 'manager', label: 'Managers' },
  { value: 'employee', label: 'Employees' },
  { value: 'bde', label: 'BDEs' },
];

export const DEPT_LABELS: Record<string, string> = Object.fromEntries(DEPT_OPTIONS.map((d) => [d.value, d.label]));
export const AUDIENCE_LABELS: Record<string, string> = Object.fromEntries(AUDIENCE_OPTIONS.map((a) => [a.value, a.label]));

/** Base path for the attachment endpoint (mirrors the axios baseURL — empty in prod). */
const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

export function attachmentUrl(file: string): string {
  return `${API_BASE}/api/attachments/${file}`;
}

export function isImageAttachment(type?: string, name?: string): boolean {
  if (type && type.startsWith('image/')) return true;
  return /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(name ?? '');
}
